// Basic debounce function
// Usage:
// const debounced = debounce(sayHi, 500);
// window.addEventListener('resize', debounced);

export default (func, wait = 100) => {
  let timeout
  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(this, args)
    }, wait)
  }
}
